import React from 'react'
import BannerSection from '../../molecules/bannerSection/bannerSection'
import ParticipaSection from '../../molecules/participaSection/participaSection'
import TopSection from '../../molecules/topSection/topSection'

const HomeContent = props => {
  const { mobile } = props

  return (
    <>
      <BannerSection mobile={mobile} />
      <ParticipaSection mobile={mobile} />
      <TopSection mobile={mobile} />
    </>
  )
}

export default HomeContent
